/**
 * Product Component Endpoints
 */

export const apiPostProductComponent = async (
  productComponent: ProductComponentCreateUpdate,
): Promise<AxiosResponse<ProductComponent>> => {
  return await userManagementAxiosInstance.post('product_components', productComponent);
};

export const apiGetProductComponents = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
  search: string = '',
): Promise<AxiosResponse<PaginatedProductComponent>> => {
  return await userManagementAxiosInstance.get(
    `product_components?limit=${limit}&offset=${offset}&name=${search}`,
  );
};

export const apiGetProductComponent = async (
  id: string | number,
): Promise<AxiosResponse<ProductComponent>> => {
  return await userManagementAxiosInstance.get(`product_components/${id}`);
};

export const apiPutProductComponent = async (
  productComponent: ProductComponentCreateUpdate,
): Promise<AxiosResponse<ProductComponent>> => {
  return await userManagementAxiosInstance.put(
    `product_components/${productComponent.id}`,
    productComponent,
  );
};

export const apiDeleteProductComponent = async (
  id: string | number,
): Promise<AxiosResponse<ProductComponent>> => {
  return await userManagementAxiosInstance.delete(`product_components/${id}`);
};
